
import { AuthorizationFailedReason } from "@moderrotech/servers-communication-library/src/types";
import { computed } from "vue";
import _ from "lodash";
import { $enum } from "ts-enum-util";

export default {
  props: {
    reason: String //  AuthorizationFailedReason | "disconnected" | "unpublished"
  },
  setup(props: object) {
    return {
      localizationPrefix: computed(
        () =>
          `error.${
            _.includes(
              $enum(AuthorizationFailedReason).getValues(),
              _.get(props, "reason")
            )
              ? "authorization"
              : _.get(props, "reason") === "disconnected"
              ? "connection"
              : "unpublished"
          }.`
      ),
      AuthorizationFailedReason,
      $enum,
      ...props
    };
  }
};
